import { getSupportedFallbackForLocale } from 'owa-shared-bootstrap/lib/getSupportedFallbackForLocale';
import { setRTL } from '@uifabric/utilities';

/**
 *  Utility to set the document direction
 * @param locale
 * @param dir
 */
export function setDocumentDirection(locale: string, dir?: 'ltr' | 'rtl') {
    let documentDirection = dir;
    if (!documentDirection) {
        documentDirection = getSupportedFallbackForLocale(locale).dir;
    }
    const isRTL = documentDirection === 'rtl';
    document.dir = documentDirection;

    setRTL(isRTL, true /* persistSetting */);
}
